var map = {
	"./ad.svg": 5105,
	"./ae.svg": 2864,
	"./af.svg": 8003,
	"./ag.svg": 66,
	"./ai.svg": 7924,
	"./al.svg": 7545,
	"./am.svg": 9624,
	"./ao.svg": 3146,
	"./aq.svg": 8668,
	"./ar.svg": 367,
	"./arab.svg": 1478,
	"./as.svg": 9262,
	"./at.svg": 4609,
	"./au.svg": 1808,
	"./aw.svg": 7685,
	"./ax.svg": 8885,
	"./az.svg": 7287,
	"./ba.svg": 3157,
	"./bb.svg": 4934,
	"./bd.svg": 5928,
	"./be.svg": 1321,
	"./bf.svg": 9946,
	"./bg.svg": 315,
	"./bh.svg": 3500,
	"./bi.svg": 6621,
	"./bj.svg": 8798,
	"./bl.svg": 6640,
	"./bm.svg": 2177,
	"./bn.svg": 2690,
	"./bo.svg": 3683,
	"./bq.svg": 8485,
	"./br.svg": 6054,
	"./bs.svg": 4087,
	"./bt.svg": 1256,
	"./bv.svg": 1034,
	"./bw.svg": 5643,
	"./by.svg": 4061,
	"./bz.svg": 5710,
	"./ca.svg": 7638,
	"./cc.svg": 5844,
	"./cd.svg": 4203,
	"./cefta.svg": 2461,
	"./cf.svg": 4521,
	"./cg.svg": 5368,
	"./ch.svg": 8255,
	"./ci.svg": 3966,
	"./ck.svg": 9228,
	"./cl.svg": 9619,
	"./cm.svg": 5394,
	"./cn.svg": 5793,
	"./co.svg": 8880,
	"./cp.svg": 8759,
	"./cr.svg": 8533,
	"./cu.svg": 6906,
	"./cv.svg": 2905,
	"./cw.svg": 7512,
	"./cx.svg": 5663,
	"./cy.svg": 3086,
	"./cz.svg": 5181,
	"./de.svg": 1363,
	"./dg.svg": 3089,
	"./dj.svg": 4324,
	"./dk.svg": 5957,
	"./dm.svg": 5675,
	"./do.svg": 2505,
	"./dz.svg": 5940,
	"./eac.svg": 3067,
	"./ec.svg": 3450,
	"./ee.svg": 9732,
	"./eg.svg": 8470,
	"./eh.svg": 6625,
	"./er.svg": 2731,
	"./es-ct.svg": 3818,
	"./es-ga.svg": 2443,
	"./es-pv.svg": 4005,
	"./es.svg": 2362,
	"./et.svg": 5573,
	"./eu.svg": 2964,
	"./fi.svg": 7209,
	"./fj.svg": 2810,
	"./fk.svg": 651,
	"./fm.svg": 3221,
	"./fo.svg": 9095,
	"./fr.svg": 9730,
	"./ga.svg": 4258,
	"./gb-eng.svg": 7046,
	"./gb-nir.svg": 101,
	"./gb-sct.svg": 4260,
	"./gb-wls.svg": 7458,
	"./gb.svg": 5009,
	"./gd.svg": 8095,
	"./ge.svg": 3454,
	"./gf.svg": 6429,
	"./gg.svg": 5420,
	"./gh.svg": 5947,
	"./gi.svg": 8426,
	"./gl.svg": 2807,
	"./gm.svg": 3830,
	"./gn.svg": 5605,
	"./gp.svg": 3779,
	"./gq.svg": 6818,
	"./gr.svg": 5505,
	"./gs.svg": 4384,
	"./gt.svg": 6908,
	"./gu.svg": 8126,
	"./gw.svg": 2204,
	"./gy.svg": 5626,
	"./hk.svg": 5441,
	"./hm.svg": 2735,
	"./hn.svg": 60,
	"./hr.svg": 7816,
	"./ht.svg": 86,
	"./hu.svg": 7623,
	"./ic.svg": 4502,
	"./id.svg": 3913,
	"./ie.svg": 8552,
	"./il.svg": 5681,
	"./im.svg": 7648,
	"./in.svg": 2307,
	"./io.svg": 4930,
	"./iq.svg": 7412,
	"./ir.svg": 5623,
	"./is.svg": 8758,
	"./it.svg": 5593,
	"./je.svg": 3329,
	"./jm.svg": 3241,
	"./jo.svg": 9211,
	"./jp.svg": 9564,
	"./ke.svg": 2818,
	"./kg.svg": 4560,
	"./kh.svg": 39,
	"./ki.svg": 2502,
	"./km.svg": 10,
	"./kn.svg": 5097,
	"./kp.svg": 1503,
	"./kr.svg": 6749,
	"./kw.svg": 5616,
	"./ky.svg": 5062,
	"./kz.svg": 6309,
	"./la.svg": 6839,
	"./lb.svg": 68,
	"./lc.svg": 1237,
	"./li.svg": 6895,
	"./lk.svg": 6813,
	"./lr.svg": 3300,
	"./ls.svg": 5909,
	"./lt.svg": 2698,
	"./lu.svg": 5448,
	"./lv.svg": 8680,
	"./ly.svg": 8927,
	"./ma.svg": 1632,
	"./mc.svg": 8146,
	"./md.svg": 7437,
	"./me.svg": 1980,
	"./mf.svg": 1007,
	"./mg.svg": 6718,
	"./mh.svg": 7273,
	"./mk.svg": 1690,
	"./ml.svg": 6613,
	"./mm.svg": 8596,
	"./mn.svg": 3191,
	"./mo.svg": 390,
	"./mp.svg": 507,
	"./mq.svg": 944,
	"./mr.svg": 7043,
	"./ms.svg": 4002,
	"./mt.svg": 7933,
	"./mu.svg": 9388,
	"./mv.svg": 8415,
	"./mw.svg": 5838,
	"./mx.svg": 5657,
	"./my.svg": 264,
	"./mz.svg": 1627,
	"./na.svg": 3577,
	"./nc.svg": 6283,
	"./ne.svg": 5941,
	"./nf.svg": 4166,
	"./ng.svg": 3143,
	"./ni.svg": 5345,
	"./nl.svg": 5756,
	"./no.svg": 8431,
	"./np.svg": 2888,
	"./nr.svg": 5962,
	"./nu.svg": 5061,
	"./nz.svg": 7154,
	"./om.svg": 6046,
	"./pa.svg": 3011,
	"./pc.svg": 1505,
	"./pe.svg": 5503,
	"./pf.svg": 2828,
	"./pg.svg": 5949,
	"./ph.svg": 9274,
	"./pk.svg": 649,
	"./pl.svg": 4262,
	"./pm.svg": 8087,
	"./pn.svg": 9876,
	"./pr.svg": 7584,
	"./ps.svg": 3537,
	"./pt.svg": 5038,
	"./pw.svg": 3389,
	"./py.svg": 4971,
	"./qa.svg": 8556,
	"./re.svg": 153,
	"./ro.svg": 8547,
	"./rs.svg": 1863,
	"./ru.svg": 1833,
	"./rw.svg": 5003,
	"./sa.svg": 2582,
	"./sb.svg": 2869,
	"./sc.svg": 1236,
	"./sd.svg": 2587,
	"./se.svg": 122,
	"./sg.svg": 7048,
	"./sh-ac.svg": 3416,
	"./sh-hl.svg": 4116,
	"./sh-ta.svg": 1501,
	"./sh.svg": 9023,
	"./si.svg": 2622,
	"./sj.svg": 5245,
	"./sk.svg": 6700,
	"./sl.svg": 8275,
	"./sm.svg": 4962,
	"./sn.svg": 1,
	"./so.svg": 6499,
	"./sr.svg": 2482,
	"./ss.svg": 2852,
	"./st.svg": 443,
	"./sv.svg": 7737,
	"./sx.svg": 2591,
	"./sy.svg": 7950,
	"./sz.svg": 925,
	"./tc.svg": 7373,
	"./td.svg": 9058,
	"./tf.svg": 800,
	"./tg.svg": 3601,
	"./th.svg": 8742,
	"./tj.svg": 3156,
	"./tk.svg": 7877,
	"./tl.svg": 6250,
	"./tm.svg": 5307,
	"./tn.svg": 6472,
	"./to.svg": 1337,
	"./tr.svg": 8716,
	"./tt.svg": 6677,
	"./tv.svg": 1856,
	"./tw.svg": 4097,
	"./tz.svg": 6916,
	"./ua.svg": 6200,
	"./ug.svg": 8886,
	"./um.svg": 6300,
	"./un.svg": 8975,
	"./us.svg": 3834,
	"./uy.svg": 8384,
	"./uz.svg": 9283,
	"./va.svg": 4785,
	"./vc.svg": 8611,
	"./ve.svg": 3677,
	"./vg.svg": 895,
	"./vi.svg": 3513,
	"./vn.svg": 6630,
	"./vu.svg": 4173,
	"./wf.svg": 1757,
	"./ws.svg": 5456,
	"./xk.svg": 5457,
	"./xx.svg": 914,
	"./ye.svg": 4760,
	"./yt.svg": 1769,
	"./za.svg": 6141,
	"./zm.svg": 7577,
	"./zw.svg": 5763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2256;